import React, { useCallback, useEffect, useState } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomMultiSelect,
  SectionTitle,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { connect } from 'react-redux'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { postDeliveryCiclesConsolidado } from '../../../../../services/api/https/deliveries/delivery.http'
import { withRouter } from 'react-router-dom'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import ListTable from '../../Trecho/ListItem/ListItem'
import { getEstadoLabel, normalizeUf } from '../../../../../services/util/estados.service'

function GerarCrossRecebimento({ ciclo, dispatch, selectedTp }) {
  const [globalFilter, setGlobalFilter] = useState('')
  const [deliveries, setDeliveries] = useState([])
  const [deliveriesOriginal, setDeliveriesOriginal] = useState([])
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [ufOptions, setUfOptions] = useState([])
  const [selectedUfs, setSelectedUfs] = useState([])
  const [citiesOptions, setCitiesOptions] = useState([])
  const [selectedCities, setSelectedCities] = useState([])
  const [bairrosOptions, setBairrosOptions] = useState([])
  const [selectedBairros, setSelectedBairros] = useState([])
  const [stepsOptions, setStepsOptions] = useState([])
  const [selectedSteps, setSelectedSteps] = useState([])

  useEffect(() => {
    fetchEntregas()
  }, [])

  const buildStepKey = step => `${step.step}|${step.tp_id || step.itemName || ''}`

  const applyFilters = useCallback(() => {
    let filtradasSemBairro = deliveriesOriginal

    if (selectedUfs.length) {
      filtradasSemBairro = filtradasSemBairro.filter(t => selectedUfs.includes(normalizeUf(t.uf)))
    }

    const nextCitiesOptions = [...new Set(filtradasSemBairro.map(t => t.city_name).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))

    if (selectedCities.length) {
      filtradasSemBairro = filtradasSemBairro.filter(t => selectedCities.includes(t.city_name))
    }

    const nextBairrosOptions = [...new Set(filtradasSemBairro.map(t => t.district).filter(Boolean))]
      .sort()
      .map(b => ({ label: b, value: b }))

    let finalFiltradas = filtradasSemBairro
    if (selectedBairros.length) {
      finalFiltradas = finalFiltradas.filter(t => selectedBairros.includes(t.district))
    }

    if (selectedSteps.length) {
      finalFiltradas = finalFiltradas.filter(t =>
        (t.steps || []).some(s => selectedSteps.includes(buildStepKey(s))),
      )
    }

    setCitiesOptions(nextCitiesOptions)
    setBairrosOptions(nextBairrosOptions)
    setDeliveries(finalFiltradas)
  }, [deliveriesOriginal, selectedUfs, selectedCities, selectedBairros, selectedSteps])

  useEffect(() => {
    applyFilters()
  }, [applyFilters])

  // Helpers
  const fetchEntregas = () => {
    CicloEntregaAcoesHttp.getEntregasByCicloId(ciclo.id)
      .then(d => {
        const ufOptionsLocal = [...new Set(d.map(e => normalizeUf(e.uf)).filter(Boolean))]
          .sort()
          .map(sigla => ({ label: getEstadoLabel(sigla), value: sigla }))
        const citiesOptionsLocal = [...new Set(d.map(e => e.city_name).filter(Boolean))]
          .sort()
          .map(c => ({ label: c, value: c }))
        const stepsRaw = d.flatMap(e => e.steps || []).filter(s => s && s.step != null)
        const stepsMap = new Map()
        stepsRaw.forEach(s => {
          const key = buildStepKey(s)
          if (!stepsMap.has(key)) {
            stepsMap.set(key, {
              label: `${s.step}- ${s.itemName}`,
              value: key,
            })
          }
        })
        const stepsOptionsLocal = Array.from(stepsMap.values()).sort((a, b) => {
          const stepA = Number(String(a.label).split('-')[0].trim()) || 0
          const stepB = Number(String(b.label).split('-')[0].trim()) || 0
          if (stepA !== stepB) return stepA - stepB
          return String(a.label).localeCompare(String(b.label))
        })

        setUfOptions(ufOptionsLocal)
        setCitiesOptions(citiesOptionsLocal)
        setBairrosOptions([])
        setStepsOptions(stepsOptionsLocal)
        setSelectedUfs([])
        setSelectedCities([])
        setSelectedBairros([])
        setSelectedSteps([])
        setDeliveries(d)
        setDeliveriesOriginal(d)
        console.log(d)

        setIsLoading(false)
      })
      .catch(e => {
        setIsLoading(false)
        dispatch(showMessageBox(null, errorHandler(e)))
      })
  }
  const onUfChange = ufs => setSelectedUfs(ufs)
  const onCityChange = cities => setSelectedCities(cities)
  const onBairroChange = bairros => setSelectedBairros(bairros)
  const onTrechoChange = trechos => setSelectedSteps(trechos)
  // Events
  const onGerarCrossRecebimento = async () => {
    try {
      if (!selectedTp) throw new Error('Selecione um operador logístico')

      const selectedDeliveries = deliveries.filter(d => d.selected)
      if (!selectedDeliveries.length) throw new Error('Nenhuma entrega selecionada')
      const { id: user_id } = getUsuarioInfo()

      await postDeliveryCiclesConsolidado({
        deliveries_ids: selectedDeliveries.map(s => s.delivery_id),
        company_id: ciclo.company_id,
        tp_id: selectedTp,
        cycleInfo: {
          name: 'Cross Recebimento – Ação 007 - ' + new Date().toLocaleDateString(),
          type: 'cross-recebimento',
        },
        user_id,
      })

      dispatch(showMessageBox('Cross-Recebimento gerado com sucesso', null))
    } catch (error) {
      console.log(error)

      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onCheckBoxClicked = (item, value) => {
    const delivery = deliveries.find(i => i.delivery_id === item.delivery_id)
    delivery.selected = value
    setDeliveries([...deliveries])
  }

  const onSelecionarTodos = () => {
    const deliveriesUpdated = deliveries.map(item => {
      item.selected = !selecionarTodos
      return item
    })
    setDeliveries(deliveriesUpdated)
    setSelecionarTodos(!selecionarTodos)
  }

  // Render
  return (
    <>
      <div className="p-grid">
        <div className="p-col-12">
          <SectionTitle title="Gerar Ciclo Cross-Recebimento" />
        </div>
        <div className="p-col-2" style={{ display: 'flex', alignItems: 'center' }}>
          <CustomCheckbox checked={selecionarTodos} onChange={() => onSelecionarTodos()}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div className="p-col-2" style={{ paddingTop: 23 }}>
          <Btn onClick={onGerarCrossRecebimento}>Gerar Cross-Recebimento</Btn>
        </div>
        <div className="p-col-12">
          <Fieldset
            legend="Filtro"
            toggleable
            collapsed={true}
            className="p-col-12"
            style={{ marginBottom: 20 }}
          >
            <div style={{ display: 'flex', gap: 16 }}>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Estados"
                  options={ufOptions}
                  value={selectedUfs}
                  onChange={onUfChange}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Cidades"
                  options={citiesOptions}
                  value={selectedCities}
                  onChange={onCityChange}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Bairros"
                  options={bairrosOptions}
                  value={selectedBairros}
                  onChange={onBairroChange}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Trechos"
                  options={stepsOptions}
                  value={selectedSteps}
                  onChange={onTrechoChange}
                />
              </div>
            </div>
          </Fieldset>
          <DataTable
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
            value={deliveries}
            emptyMessage="Não existe Entrega associada a este Ciclo"
            rows={10}
            paginator
            loading={isLoading}
          >
            <Column
              header="#"
              body={item => (
                <CustomCheckbox
                  checked={item.selected}
                  onChange={value => onCheckBoxClicked(item, value)}
                />
              )}
              style={tableCellCentered(80)}
            />
            <Column field="client_fantasia" header="Cliente" />
            <Column sortable field="city_name" header="Cidade" />
            <Column sortable field="district" header="Bairro" style={tableCellCentered(150)} />
            <Column
              sortable
              field={'identifier'}
              header="Identificador"
              style={tableCellCentered(200)}
            />
            <Column field="qteSKU" header="Qte Sku" style={tableCellCentered()} />
            <Column
              field="steps"
              header="Trechos"
              style={tableCellCentered(250)}
              body={item => <ListTable items={item.steps || []} />}
            />
          </DataTable>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(GerarCrossRecebimento))
